import { __assign } from "tslib";
import { Observable, consoleObserver, getGlobalScope, merge } from '@amplitude/analytics-core';
/* eslint-disable-next-line no-restricted-globals */
var globalScope = getGlobalScope();
export var createMutationObservable = function () {
    return new Observable(function (observer) {
        var mutationObserver = new MutationObserver(function (mutations) {
            observer.next(mutations);
        });
        if (document.body) {
            mutationObserver.observe(document.body, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true,
            });
        }
        return function () { return mutationObserver.disconnect(); };
    });
};
/**
 * Creates an observable that tracks click events on the document.
 * @param clickType - The type of click event to track (click or pointerdown)
 */
export var createClickObservable = function (clickType) {
    if (clickType === void 0) { clickType = 'click'; }
    return new Observable(function (observer) {
        var handler = function (event) {
            observer.next(event);
        };
        globalScope.document.addEventListener(clickType, handler, { capture: true });
        return function () {
            globalScope.document.removeEventListener(clickType, handler, { capture: true });
        };
    });
};
var createConsoleErrorObservable = function () {
    return new Observable(function (observer) {
        var handler = function (_) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            /* istanbul ignore next */
            var message = undefined;
            if (Array.isArray(args[0]) && typeof args[0][0] === 'string') {
                message = args[0][0];
            }
            observer.next({ kind: 'console', message: message });
        };
        consoleObserver.addListener('error', handler);
        return function () {
            consoleObserver.removeListener(handler);
        };
    });
};
var createUnhandledErrorObservable = function () {
    return new Observable(function (observer) {
        var handler = function (event) {
            if (!(event instanceof ErrorEvent)) {
                return;
            }
            var output = {
                kind: 'error',
            };
            if (event.error instanceof Error || event.error instanceof DOMException) {
                output = __assign(__assign({}, output), { message: event.error.message, stack: event.error.stack, filename: event.filename, lineNumber: event.lineno, columnNumber: event.colno });
            }
            else if (typeof event.error === 'string') {
                output.message = event.error;
            }
            observer.next(output);
        };
        globalScope.addEventListener('error', handler);
        return function () {
            globalScope.removeEventListener('error', handler);
        };
    });
};
var createUnhandledRejectionObservable = function () {
    return new Observable(function (observer) {
        var handler = function (event) {
            var output = {
                kind: 'unhandledrejection',
            };
            if (event.reason instanceof Error || event.reason instanceof DOMException) {
                output.message = event.reason.message;
                output.stack = event.reason.stack;
            }
            else if (typeof event.reason === 'string') {
                output.message = event.reason;
            }
            observer.next(output);
        };
        globalScope.addEventListener('unhandledrejection', handler);
        return function () {
            globalScope.removeEventListener('unhandledrejection', handler);
        };
    });
};
export var createErrorObservable = function () {
    var unhandledErrorObservable = merge(createUnhandledErrorObservable(), createUnhandledRejectionObservable());
    return merge(unhandledErrorObservable, createConsoleErrorObservable());
};
export var createMouseMoveObservable = function () {
    return new Observable(function (observer) {
        var handler = function (event) {
            observer.next(event);
        };
        var args = { capture: true };
        globalScope.document.addEventListener('mousemove', handler, args);
        return function () {
            globalScope.document.removeEventListener('mousemove', handler, args);
        };
    });
};
//# sourceMappingURL=observables.js.map